(function(){
  function pills(){
    document.querySelectorAll('#product-form-main .variant-select').forEach(function(wrap){
      if (wrap.classList.contains('pdp-has-pills')) return;
      var sel = wrap.querySelector('select[data-option-select]'); if (!sel) return;
      var box = document.createElement('div'); box.className = 'pdp-pills'; box.setAttribute('role','group');
      var lab = wrap.querySelector('label'); if (lab) { if(!lab.id) lab.id = sel.id + '-label'; box.setAttribute('aria-labelledby', lab.id); }
      Array.prototype.forEach.call(sel.options, function(o){
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pdp-pill'; b.textContent = o.textContent; b.dataset.value = o.value;
        b.addEventListener('click', function(){
          if (sel.value === o.value) return;
          sel.value = o.value;
          sel.dispatchEvent(new Event('input', {bubbles:true}));
          sel.dispatchEvent(new Event('change', {bubbles:true}));
          sync();
        });
        box.appendChild(b);
      });
      function sync(){ box.querySelectorAll('.pdp-pill').forEach(function(b){ b.setAttribute('aria-pressed', String(b.dataset.value === sel.value)); }); }
      sel.addEventListener('change', sync); sync();
      sel.setAttribute('tabindex','-1'); sel.setAttribute('aria-hidden','true');
      sel.insertAdjacentElement('afterend', box);
      wrap.classList.add('pdp-has-pills');
    });
  }
  function sticky(){
    if (document.querySelector('.pdp-sticky') || !document.querySelector('#product-form-main [data-add-button]')) return;
    var bar = document.createElement('div'); bar.className = 'pdp-sticky'; bar.setAttribute('aria-hidden','true');
    var btn = document.createElement('button'); btn.type = 'button'; btn.tabIndex = -1;
    var info = document.createElement('div'); info.className = 'pdp-sticky-info';
    var tEl = document.querySelector('.section_product .product_right .g_heading, .section_product h1');
    if (tEl) { var tt = document.createElement('div'); tt.className = 'pdp-sticky-title'; tt.textContent = tEl.textContent.trim(); info.appendChild(tt); }
    var row = document.createElement('div'); row.className = 'pdp-sticky-row';
    row.appendChild(info); row.appendChild(btn); bar.appendChild(row); document.body.appendChild(bar);
    var foot = document.querySelector('footer, .footer_wrap, [class*="footer_"]'), footIn = false;
    if (foot && 'IntersectionObserver' in window) { new IntersectionObserver(function(es){ footIn = es[0].isIntersecting; req(); }).observe(foot); }
    function cartOpen(){ var c = document.querySelector('.nav1_cart'); if (!c) return false; var cs = getComputedStyle(c); if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) return false; var r = c.getBoundingClientRect(); return r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth; }
    var mo = new MutationObserver(function(){ req(); }); var cw = document.querySelector('.nav1_cart_wrap, .nav1_cart'); if (cw) mo.observe(cw, {attributes:true, subtree:true, attributeFilter:['class','style']});
    function main(){ return document.querySelector('#product-form-main [data-add-button]'); }
    function copy(m){
      if (btn.className !== m.className) btn.className = m.className;
      ['data-button','data-button-size','data-wf--ecom-add-to-cart--style','data-disabled'].forEach(function(a){ if (m.hasAttribute(a)) btn.setAttribute(a, m.getAttribute(a)); });
      var t = []; m.querySelectorAll('.btn_main_text').forEach(function(e){ t.push(e.textContent); });
      if (btn.dataset.sig !== t.join('|')) { btn.innerHTML = ''; t.forEach(function(x){ var d = document.createElement('div'); d.className = 'btn_main_text'; d.textContent = x; btn.appendChild(d); }); btn.dataset.sig = t.join('|'); }
    }
    btn.addEventListener('click', function(){ var m = main(); if (!m) return; m.scrollIntoView({block:'center'}); m.click(); });
    var ticking = false;
    function update(){
      ticking = false; var m = main(); if (!m) return;
      var r = m.getBoundingClientRect();
      var pop = document.querySelector('[data-engraving-popup][data-visible="true"]');
      var menuOpen = !!document.querySelector('[data-menu-status="open"]');
      var show = r.bottom < 0 && !pop && !footIn && !menuOpen && !cartOpen() && !document.documentElement.classList.contains('pc-lb-lock') && window.innerWidth < 992;
      if (show) copy(m);
      if (show !== bar.classList.contains('is-visible')) { bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', String(!show)); btn.tabIndex = show ? 0 : -1; }
      document.body.classList.toggle('pdp-sticky-on', show);
      if (show) document.body.style.setProperty('--pdp-sticky-h', bar.offsetHeight + 'px');
    }
    function req(){ if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', req, {passive:true}); window.addEventListener('resize', req); req();
  }
  function init(){ try{ pills(); }catch(e){} try{ sticky(); }catch(e){} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
